import axios, { AxiosPromise, AxiosResponse } from 'axios'
import { isArray, isEmpty, values } from 'lodash'

import { TItemTable } from './types'

type typeGlobal = typeof globalThis
interface TGlobal extends typeGlobal {
  bearertoken?: string
}

interface IResultPage {
  itemsById: {
    [key: string]: TItemTable
  }
  itemsByIndex: {
    [key: number]: number
  }
  page: number
  totalCount: number
  customData: any
  allIds?: Array<number>
}

const GlobalObject: TGlobal = global

const PAGE_SIZE = 15

export function* requestPage(
  url: string,
  page = 1,
  filter = {},
  customHeaders = {},
  customPayload = {},
  customAxiosClient = undefined,
): Generator<AxiosPromise<any>, IResultPage, AxiosResponse> {
  const defaultHeaders = customAxiosClient
    ? {
        headers: { 'Accept-Language': i18n?.language ?? 'de' },
      }
    : {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${GlobalObject.bearertoken}`,
          'Accept-Language': i18n?.language ?? 'de',
        },
        validateStatus: (status: number) => status === 200,
      }

  const payload = { ...filter, page, customHeaders, ...customPayload }

  const client = customAxiosClient || axios

  let { data } = yield client({
    ...defaultHeaders,
    method: 'post',
    url,
    data: payload,
  })
  const itemsByIndex = {}
  const itemsById = {}

  data = { ...data, data: values(data.data) }
  if (isArray(data) && isEmpty(data)) {
    return {
      itemsById: {},
      itemsByIndex: [],
      customData: {},
      page,
      totalCount: 0,
    }
  }

  for (let i = 0; i < PAGE_SIZE; i++) {
    const index = (page - 1) * PAGE_SIZE + i
    const item = data.data[i]
    if (!item) continue
    itemsByIndex[index] = item.id
    itemsById[item.id] = item
  }
  return {
    itemsById,
    itemsByIndex,
    page,
    totalCount: data.total,
    customData: data.customData,
    allIds: data.allIds,
  }
}

export function getPageOfIndex(index: number): number {
  return Math.floor(index / PAGE_SIZE) + 1
}
